<div class="pb-4">
  <form
    class="fs-7 d-flex flex-wrap gap-2"
    [formGroup]="filtersForm"
  >
    <base-filter-dropdown
      [items]="baseInquiryStatusOption"
      formControlName="status"
      filterName="state"
      optionClass="class"
    ></base-filter-dropdown>

    <base-filter-dropdown
      [items]="qualifications"
      filterName="qualifications.plural"
      formControlName="mainQualifications"
      [searchable]="true"
    ></base-filter-dropdown>

    <base-filter-dropdown
      [items]="departments"
      filterName="department.singular"
      formControlName="customerDepartments"
      [searchable]="true"
      [displaySubLabel]="true"
      [optionSubLabelSegments]="['customerLocation', 'name']"
    ></base-filter-dropdown>

    <base-filter-dropdown
      [items]="locations"
      filterName="location.singular"
      formControlName="customerLocations"
      [searchable]="true"
    ></base-filter-dropdown>

    <base-filter-dropdown
      formControlName="createdBy"
      [items]="createdByCustomers"
      filterName="filter.createdBy"
      [multiple]="false"
      [combineLabel]="['firstName', 'lastName']"
    ></base-filter-dropdown>
  </form>

  <hr *ngIf="activeFilters.length" />

  <div
    *ngIf="activeFilters.length > 0"
    class="fs-7 d-flex align-items-center flex-wrap gap-2"
  >
    <div
      *ngFor="let filter of activeFilters"
      class="px-2_5 rounded-pill bg-secondary py-2 active-filter fw-semibold"
    >
      <span class="fw-normal">
        {{
          filter.filter === baseCustomerInquiryFilters.status
            ? ('state' | translate)
            : filter.filter === baseCustomerInquiryFilters.department
            ? ('department.singular' | translate)
            : filter.filter === baseCustomerInquiryFilters.location
            ? ('location.singular' | translate)
            : filter.filter === baseCustomerInquiryFilters.mainQualification
            ? ('qualifications.singular' | translate)
            : filter.filter === baseCustomerInquiryFilters.search
            ? ('search.nominative' | translate)
            : ('filter.createdBy' | translate)
        }}:
      </span>
      {{
        (filter.value?.firstName && filter.value?.lastName
          ? filter.value.firstName + ' ' + filter.value.lastName
          : null) ||
          filter?.name ||
          filter.value?.name ||
          filter.value | translate
      }}
      <i
        class="fa-solid fa-xmark text-dark ms-2 pointer"
        (click)="removeFilter(filter)"
      ></i>
    </div>
    <span
      class="pointer"
      (click)="clearFilters()"
      *ngIf="activeFilters.length"
    >
      {{ 'filter.reset' | translate }}
    </span>
  </div>
</div>

<div class="row flex-wrap align-items-center justify-content-between my-5">
  <div class="col-12 col-md pb-4 pb-md-0">
    <base-search
      #searchField
      class="d-block mw-100 max-w-md-500px"
      placeholder="inquiry.search.fullTextPlaceholder"
      [value]="activatedRoute.snapshot.queryParams.search"
      [useEnterEvent]="true"
      (query)="onSearchChange($event)"
    ></base-search>
  </div>
  <div class="col-md-auto d-flex justify-content-end">
    <base-button
      icon="fa-solid fa-plus"
      [iconSize]="buttonSizes.md"
      label="inquiry.new"
      (btnClick)="openNewStaffRequestModal()"
      color="primary"
    ></base-button>
  </div>
</div>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [selectedFilters]="filtersForm.value"
    [modalRef]="modalRef"
  ></base-customer-staff-request-modal>
</ng-template>
